import { ToastsContainer } from '@hivebrite/design-system/Toast';

import useToastVerticalInset from '../hooks/useToastVerticalInset';

const ToastsApp = ({ env }) => {
  const verticalInset = useToastVerticalInset(env);

  return <ToastsContainer verticalInset={verticalInset} />;
};

export default ToastsApp;
